<template>
  <div class="import_dado">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="page-header">Importar Dados</h2>
      </div>
    </div>
    <div class="row margem-bottom">
      <div class="col-xs-12">
        <upload @loadCSV="loadCSV" :separador="';'" />
      </div>
    </div>
    <div v-if="model.body.length" class="row">
      <div class="col-xs-12">
        <h3>Pré Visualização</h3>
      </div>
      <div class="col-xs-12">
        <data-table :dados="model.body" :fields="fields"> </data-table>
      </div>
      <div class="col-xs-12 margem-bottom">
        <button
          @click.prevent="salvar()"
          class="btn btn-default"
          :disabled="carregando"
        >
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '@/components/common/CSVImport'
import DataTable from '@/components/common/NoApiTable'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  components: { upload, DataTable },
  data() {
    return {
      carregando: false,
      model: {
        header: [],
        body: []
      },
      periodicidades: [],
      eixos: [],
      metas: [],
      tags: [],
      secretarias: [],
      fields: [
        {
          name: 'NOME',
          title: 'NOME'
        },
        {
          name: 'DESCRIÇÃO',
          title: 'DESCRIÇÃO'
        },
        {
          name: 'FONTE',
          title: 'FONTE'
        },
        {
          name: 'TIPO VALOR',
          title: 'TIPO VALOR'
        },
        {
          name: 'PERIODICIDADE',
          title: 'PERIODICIDADE'
        },
        {
          name: 'TAG',
          title: 'TAG'
        },
        {
          name: 'EIXO',
          title: 'EIXO'
        },
        {
          name: 'METAS',
          title: 'METAS'
        },
        {
          name: 'SECRETARIAS',
          title: 'SECRETARIAS'
        }
      ]
    }
  },
  created() {
    request
      .get('meta/listar')
      .then(response => {
        this.metas = response.data.data
      })
      .catch(error => {
        console.log(error.message)
      })
    request
      .get('eixos/listar')
      .then(response => {
        this.eixos = response.data.data
      })
      .catch(error => {
        console.log(error.message)
      })
    request
      .get('tags/listar')
      .then(response => {
        this.tags = response.data.data
      })
      .catch(error => {
        console.log(error.message)
      })
    request
      .get('listar-periodicidades')
      .then(response => {
        this.periodicidades = response.data.data
      })
      .catch(error => {
        console.log(error.message)
      })
    request
      .get('filtrar-secretarias/1')
      .then(response => {
        this.secretarias = response.data.data
      })
      .catch(error => {
        console.log(error.message)
      })
  },
  methods: {
    loadCSV(payload) {
      this.model.header = payload.header
      this.model.body = payload.body
    },
    salvar() {
      const me = this
      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: () => {
          me.carregando = !me.carregando
          request
            .post('dado/importar', this.rawInfo)
            .then(response => {
              this.$toastr.s(response.data)
              this.$router.push('/admin/dado/list')
            })
            .catch(error => {
              const { data } = error.response
              this.$toastr.e(
                `Houve um erro na importação dos dados, verifique o arquivo na linha ${data.linha} e tente novamente.`
              )
              console.log(data.msg)
            })
            .finally(() => {
              me.carregando = !me.carregando
            })
        }
      }
      this.showConfirm('Confirmar a inserção dos itens?', config)
    },
    filtrarEixo(desc_eixo) {
      const descricao = desc_eixo.toLowerCase()
      const eixos = this.eixos.filter(item => {
        return item.descricao.toLowerCase() === descricao
      })

      return eixos
    },
    filtrarPeriodicidade(desc_periodicidade) {
      return this.periodicidades.find(item => {
        return item.descricao.toLowerCase() === desc_periodicidade.toLowerCase()
      })
    },
    filtrarTag(desc_tag) {
      const descricao = desc_tag.toLowerCase()
      const tags = this.tags.filter(item => {
        return item.descricao.toLowerCase() === descricao
      })

      return tags
    },
    filtrarMetas(desc_metas) {
      const nr_metas = desc_metas.split(',')
      const metas = this.metas.filter(item => {
        return nr_metas.includes(item.numero.toString())
      })
      return metas
    },
    filtrarSecretaria(desc_secretaria) {
      const nr_secretarias = desc_secretaria.split(',')
      const secretarias = this.secretarias.filter(item => {
        return nr_secretarias.includes(item.sigla)
      })
      return secretarias
    }
  },
  computed: {
    rawInfo() {
      return this.model.body.map(item => {
        const eixo = this.filtrarEixo(item.EIXO) || { codigo: item.EIXO }
        const periodicidade = this.filtrarPeriodicidade(item.PERIODICIDADE) || {
          codigo: item.PERIODICIDADE
        }
        const tag = this.filtrarTag(item.TAG) || { codigo: item.TAG }
        const meta = this.filtrarMetas(item.METAS) || []
        const secretarias = this.filtrarSecretaria(item.SECRETARIAS) || []

        const mapper = item => {
          return item.codigo || null
        }

        return {
          ...item,
          EIXO: eixo.map(mapper),
          PERIODICIDADE: periodicidade.codigo,
          TAG: tag.map(mapper),
          METAS: meta.map(mapper),
          SECRETARIAS: secretarias
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/dados/Import.vue